import React, { useState, useEffect } from 'react';
import { Navbar, Dropdown, Breadcrumb, Image,Alert} from 'react-bootstrap';
import styles from './customNavbar.module.scss';
import { logout} from '../../../services/util/auth';
import { getUserAlerts } from '../../../services/util/userNotification';
import { useNavigate } from 'react-router-dom';

const CustomNavbar = (props) => {
    const history = useNavigate();
    let values = props.breadcrumbArray;
    let [userAlerts, setUserAlerts] = useState({
        total_alert_count:0,
        overall_alart_type:0,
        alerts : []
    });
    let [activeUrl,setActiveUrl] = useState(false);

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a 
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                </div>
                <div className={styles.arrowIconSvgDiv}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 7.5L10 12.5L15 7.5" stroke="#2DA6C0" strokeOpacity="0.75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    const CustomAlertToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a 
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.alertBox}>  
                {userAlerts.total_alert_count >0 && <div className={(userAlerts.overall_alart_type === -20) ? styles.alertCountDangerIndicator : userAlerts.overall_alart_type === -10 ? styles.alertCountWarningIndicator : styles.alertCountDefaultIndicator }>{userAlerts.total_alert_count}</div>}
                                
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </a>
    ));

    function goToAlertLink(value) {
        if (value === 1001) {
            window.location.replace('/app/company/settings/integrations')
        }
        if (value === 1002) {
            props.history("/my-settings/calendar");
        }
    }

    const dropdownSelect = (e) =>{
        if(e === '1'){
            history("/my-settings/user-info")
        }
        if(e === '2'){
            history('/my-settings/customer-support')
        }
        if(e === '3'){
            logout()
            history("/signin")
        }
    }

    const goToSupportPage = () => {
        props.history("/my-settings/customer-support")
    }

    const refreshUserAlerts = () =>{
        GetUserAlerts();
    }

    const GetUserAlerts = async () => {
        let respond = await getUserAlerts();
        if (respond.success) {

            let userAlerts = {
                total_alert_count:respond.data.total_alert_count,
                overall_alart_type:respond.data.overall_alerts_type,
                alerts: respond.data.user_alerts,
                userAccessEnabledToFix: respond.data.user_access_enabled_to_fix
            }
            setUserAlerts(userAlerts);
        }
    }

    useEffect(() => {
        GetUserAlerts();

        const interval = setInterval(() => {
            GetUserAlerts();
          }, 600000); // refresh alerts in 10mins intervals

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        let pathArrays = window.location.pathname.split('/');

        if(pathArrays[3] === "pipelines" && pathArrays[4]){
            setActiveUrl(true);
        }
        else if(pathArrays[3] === "analytics"){
            setActiveUrl(true);
        }
        else if(pathArrays[3] === "templates"){
            setActiveUrl(true);
        }
        else if(pathArrays[3] === "settings"){
            setActiveUrl(true);
        }
        else if(pathArrays[3] === "interview-template"){
            setActiveUrl(true);
        }
        else {
            setActiveUrl(false);
        }
    },[])
    

    return (
        <div>
            <Navbar expand="lg" className={styles.navbarCustom}>
                <div className="me-auto">
                    <div>
                        <Breadcrumb
                            className={styles.breadcrumbClass}
                        >
                            {values &&
                                values.map((value) => (
                                    <Breadcrumb.Item href={value.pathaddress} active={value.isActive === true ? true : false} key={value.key} className={value.isActive === true ? styles.breadcrumb : styles.highlightedBreadcrumb}>{value.pathname}</Breadcrumb.Item>
                                ))
                            }                            
                        </Breadcrumb>
                        <div className={styles.breadcrumbTextOuterClass}>
                            {props.breacrumbText && <p className={styles.breadcrumbTextClass}> {props.breacrumbText}</p>}
                        </div>
                        
                    </div>
                </div>
                <div>

                    <Dropdown
                        onSelect={(e) => dropdownSelect(e)}
                    >
                        <Dropdown.Toggle as={CustomAlertToggle}></Dropdown.Toggle>

                        <Dropdown.Menu className={styles.alertDropdownMenu} align="end">
                        <div className={styles.alertDropdownMenuArrowUp}></div>
                        {(userAlerts.alerts).length > 0 ?
                                (userAlerts.alerts).map((value, index) => (
                                    <Alert key={"light"} variant={"light"} className={styles.alertMessage}>
                                        
                                            <div  className={styles.alertMessageIconBox}>
                                                <svg
                                                    className={`
                                                        ${value.alert_type === 0 && styles.defaultAlertIcon}
                                                        ${value.alert_type === -10 && styles.warningAlertIcon}
                                                        ${value.alert_type === -20 && styles.dangerAlertIcon}
                                                    `} 
                                                        width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M12 8V12"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M12 16H12.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                            <div className={styles.alertMessageTextBox}>
                                                <p className={styles.alertMessageText}>{value.message}. {(value.alert_code === 1001 || value.alert_code === 1002) && userAlerts.userAccessEnabledToFix ? <a onClick={ () =>goToAlertLink(value.alert_code)} className={styles.alertMessageLink}>Fix it</a> : null}</p>
                                            </div>
                                    </Alert>
                                )):
                                <div><p className={styles.noNotificationsications}>You have no notifications</p></div>
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                    
                </div>
                <div className={styles.userDetails}>
                    <div>
                        <svg className={styles.mainSvg} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="40" height="40" rx="20" fill="#F2F4F7"/>
                            <path d="M19.0475 19.0478H14.4761C13.4093 19.0478 12.8759 19.0478 12.4685 19.2554C12.1101 19.438 11.8187 19.7294 11.6361 20.0878C11.4285 20.4952 11.4285 21.0286 11.4285 22.0954V28.5716M28.5713 28.5716V14.4763C28.5713 13.4096 28.5713 12.8762 28.3637 12.4687C28.1811 12.1103 27.8897 11.8189 27.5313 11.6363C27.1238 11.4287 26.5905 11.4287 25.5237 11.4287H22.0951C21.0284 11.4287 20.495 11.4287 20.0875 11.6363C19.7291 11.8189 19.4377 12.1103 19.2551 12.4687C19.0475 12.8762 19.0475 13.4096 19.0475 14.4763V28.5716M29.5237 28.5716H10.4761M22.3808 15.2382H25.238M22.3808 19.0478H25.238M22.3808 22.8573H25.238" stroke="#475467" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div>
                        <p className={styles.currentUserName}>{localStorage.getItem("name")}</p>
                        <p className={styles.currentUserCompanyName}>{localStorage.getItem("companyName")}</p>
                    </div>            
                    <Dropdown
                        onSelect={(e) => dropdownSelect(e)}
                    >
                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={styles.dropdownMenu} align="end">
                            <div className={styles.userDetailsBox}>
                                <div className={styles.userAvatarContainer}>
                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/navigation_dropdown_avatar.png`} fluid className={styles.userAvatar}/>
                                </div>
                                <div className={styles.userDetailsContainer}>
                                    <p className={styles.userDetailsTopic}>{localStorage.getItem("name")}</p>
                                </div>
                            </div>
                            <Dropdown.Item eventKey="1" className={styles.dropdownText}><i className={`${styles.changePasswordIcon} ${"fas fa-cog"}`}></i>My Settings</Dropdown.Item>
                            <Dropdown.Item eventKey="2" className={styles.dropdownText}><i className={`${styles.signoutIcon} ${"fas fa-question-circle"}`}></i>Help</Dropdown.Item>
                            <Dropdown.Item eventKey="3" className={styles.dropdownTextLogout} id="adminPanel_customNavbar_userDetailsDropdown_logoutBtnId"><i className={`${styles.signoutIcon} ${"fas fa-sign-out-alt"}`}></i>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Navbar>
            {!activeUrl &&
                <hr className={styles.subTopicDivider} />
            }
            
        </div>
    )
}

export default CustomNavbar;
